import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpRequest, HttpParams } from '@angular/common/http';
import { Observable, ReplaySubject, Subject, of } from 'rxjs';
import { TranslateService } from './translate.service';
import { ApiRequestService } from './api-request.service';
import { filter, delay, share } from 'rxjs/operators';
import { environment } from 'environments/environment';

@Injectable({ providedIn: 'root' })
export class RuleEngineService {
   env=environment
    constructor(
        private apiRequest: ApiRequestService,
        private translate: TranslateService
    ) { }

    getRider(quotationIO) {
        var self = this;
        let riderDataSubject: Subject<any> = new Subject<any>();
        var temList = [{ 'Flood': 'OPTIONAL' }]
        let fetchRidersListURL = "masterQuotationRidersList/"
        this.apiRequest.postCallWithAPIMapper(fetchRidersListURL, quotationIO)
            .subscribe(
                jsonResp => {
                    if (jsonResp !== undefined) {
                        console.log("Riders Fetched")
                        console.log(jsonResp)
                    } else {
                        console.log("Rider hardcoded")
                        console.log(jsonResp)
                    }
                    riderDataSubject.next(jsonResp);

                },
                errResp => {
                    console.log("POST ERROR")
                    riderDataSubject.next(temList);
                })
        return riderDataSubject;
    }

    fetchRiders(product) {
        let riderListSubject: Subject<any> = new Subject<any>();
        // let riderListServiceURL = 'api/product/fetchRiders/' + product;
        let riderListServiceURL = 'productFetchRiders/' + product;
        let DataList: any[] = [];
        this.apiRequest.getCallWithAPIMapper(riderListServiceURL)
            .subscribe(jsonResp => {
                if (jsonResp && Array.isArray(jsonResp) && jsonResp.length > 0) {
                    jsonResp.forEach(element => {
                        DataList.push(element);
                    });

                    riderListSubject.next(DataList);
                    riderListSubject.complete();
                }

            })

        return riderListSubject;

    }

    metaDataCallSubjects: any = {}
    getMetaDataByMetaDataCache = {}
    fetchRuleMetadata(ruleCategory) {

        if (this.getMetaDataByMetaDataCache[ruleCategory]) {
            return of(this.getMetaDataByMetaDataCache[ruleCategory]).pipe(delay(100));
        } else if (this.metaDataCallSubjects[ruleCategory]) {
            return this.metaDataCallSubjects[ruleCategory]
        } else {

            // let url = 'master/ruleEngineController/getRuleMetaData/' + ruleCategory;
            let url = 'masterRuleEngineControllerGetRuleMetaData/' + ruleCategory;
            this.metaDataCallSubjects[ruleCategory] = new Subject<any>();
            this.apiRequest.getCallWithAPIMapper(url)
                .pipe(share()).subscribe(jsonResp => {
                    let returnObj = jsonResp;
                    this.metaDataCallSubjects[ruleCategory].next(returnObj); // incidentList is a Subject and emits an event thats being listened to by the components
                    this.getMetaDataByMetaDataCache[ruleCategory] = returnObj
                });
        }

        return this.metaDataCallSubjects[ruleCategory];

    }
    fetchRuleMetadata_New(ruleType, ruleSubType) {
        let pathVariables =[]
        pathVariables.push(ruleType || null);
        pathVariables.push(ruleSubType || null);

        if (this.getMetaDataByMetaDataCache[ruleSubType]) {
            return of(this.getMetaDataByMetaDataCache[ruleSubType]).pipe(delay(100));
        } else if (this.metaDataCallSubjects[ruleSubType]) {
            return this.metaDataCallSubjects[ruleSubType]
        } else {

            let url = 'masterRuleEngineGetRuleMetaDataBySubType/';
            // let url = `master/ruleEngineController/getRuleMetaData/${ruleType[0]}/${ruleSubType}`
            this.metaDataCallSubjects[ruleSubType] = new Subject<any>();
            this.apiRequest.getCallWithAPIMapper(url,null,true,pathVariables)
                .pipe(share()).subscribe(jsonResp => {
                    let returnObj = jsonResp;
                    this.metaDataCallSubjects[ruleSubType].next(returnObj); // incidentList is a Subject and emits an event thats being listened to by the components
                    this.getMetaDataByMetaDataCache[ruleSubType] = returnObj
                });
        }

        return this.metaDataCallSubjects[ruleSubType];

    }

}


